import { gql } from "@apollo/client"

export const CREATE_ASSIGNMENT_MUTATION = gql`
  mutation createAssignment($data: CreateAssignmentRequest!) {
    assignments {
      createAssignment(data: $data) {
        success
        id
      }
    }
  }
`

export const UPDATE_ASSIGNMENT_MUTATION = gql`
  mutation updateAssignment($data: UpdateAssignmentRequest!) {
    assignments {
      updateAssignment(data: $data) {
        success
      }
    }
  }
`

export const DELETE_ASSIGNMENT_MUTATION = gql`
  mutation deleteAssignment($data: DeleteAssignmentRequest!) {
    assignments {
      deleteAssignment(data: $data) {
        success
      }
    }
  }
`

export const CLOSE_ASSIGNMENT_MUTATION = gql`
  mutation closeAssignment($data: CloseAssignmentRequest!) {
    assignments {
      closeAssignment(data: $data) {
        success
      }
    }
  }
`
